import { createAsyncThunk } from '@reduxjs/toolkit';

import { Property } from '../../types/PropertySchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface UpdateInOrderSavingsDisplayParams {
    propertyId: string;
    isInOrderSavingsEnabled: boolean;
}

export const updateInOrderSavingsDisplay = createAsyncThunk<
    Property,
    UpdateInOrderSavingsDisplayParams,
    ThunkConfig<string>
>(
    'property/updateInOrderSavingsDisplay',
    async ({ propertyId, isInOrderSavingsEnabled }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const response = await extra.api.patch<Property>(
                `/v1/properties/${propertyId}/in-order-savings`,
                { isInOrderSavingsEnabled },
            );

            return response.data;
        } catch {
            return rejectWithValue('error');
        }
    },
);
